
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as CalculatorDRJMJ1b3uAMeta } from "/app/pages/Calculator.vue?macro=true";
import { default as cart9SktLKPpbzMeta } from "/app/pages/cart.vue?macro=true";
import { default as ContactsW7WazZS6xwMeta } from "/app/pages/Contacts.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as partnershipt8vvboU817Meta } from "/app/pages/partnership.vue?macro=true";
import { default as privacyg3gwBRGXatMeta } from "/app/pages/privacy.vue?macro=true";
import { default as _91slug_9351gp66KtUtMeta } from "/app/pages/products/[category]/[slug].vue?macro=true";
import { default as indexlldwW6osqyMeta } from "/app/pages/products/[category]/index.vue?macro=true";
import { default as index18IXo8oN8QMeta } from "/app/pages/products/index.vue?macro=true";
import { default as ServiceswTXq4BCgUjMeta } from "/app/pages/Services.vue?macro=true";
export default [
  {
    name: "Calculator",
    path: "/calculator",
    meta: CalculatorDRJMJ1b3uAMeta || {},
    alias: ["/Calculator"],
    component: () => import("/app/pages/Calculator.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "Contacts",
    path: "/contacts",
    meta: ContactsW7WazZS6xwMeta || {},
    alias: ["/Contacts"],
    component: () => import("/app/pages/Contacts.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "partnership",
    path: "/partnership",
    component: () => import("/app/pages/partnership.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "products-category-slug",
    path: "/products/:category()/:slug()",
    meta: _91slug_9351gp66KtUtMeta || {},
    component: () => import("/app/pages/products/[category]/[slug].vue")
  },
  {
    name: "products-category",
    path: "/products/:category()",
    component: () => import("/app/pages/products/[category]/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/app/pages/products/index.vue")
  },
  {
    name: "Services",
    path: "/services",
    meta: ServiceswTXq4BCgUjMeta || {},
    alias: ["/Services"],
    component: () => import("/app/pages/Services.vue")
  }
]